import { arenaTabs } from "@/mocks/homeData";

export default function ArenaSection() {
  return (
    <section id="arena" className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
              <i className="ri-apps-2-line text-lg"></i>
            </span>
            <h3 className="font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
              六大吃瓜分区
            </h3>
          </div>
          <p className="mt-3 text-sm text-foreground-500 md:text-base">
            你对哪个圈子感兴趣，就直接跳进对应瓜田，追得更有方向。
          </p>
        </div>
        <p className="hidden text-sm text-foreground-400 md:block">榜单覆盖 6 大分区 · 数据实时聚合</p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {arenaTabs.map((a) => (
          <a
            key={a.key}
            href="#rank"
            className="group flex flex-col gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-primary-50/50"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-background-100 text-foreground-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${a.icon} text-xl`}></i>
            </span>
            <div>
              <p className="font-heading text-base font-bold text-foreground-950">{a.key}</p>
              <p className="mt-1 text-xs leading-5 text-foreground-500">{a.desc}</p>
            </div>
            <span className="font-num text-sm text-primary-600">{a.count} 个热瓜</span>
          </a>
        ))}
      </div>
    </section>
  );
}